import React, { PropsWithChildren } from "react";
import _isUndefined from "lodash/isUndefined";
import { Navigate } from "react-router-dom";
import { useLaunchDarklyFlags, FEATURE_FLAGS } from "shared-services";
import { Spinner } from "component-library";
import { JOINING_APP_ROUTES } from "../../config/common";

type Props = PropsWithChildren<{
  flagName: FEATURE_FLAGS;
}>;

// this component can be shared one when we finish react routers ticket
const FeatureFlagProtectedRoute = ({ flagName, children }: Props) => {
  const isFlagEnabled = useLaunchDarklyFlags(flagName);

  if (_isUndefined(isFlagEnabled)) return <Spinner />;

  if (!isFlagEnabled) return <Navigate to={JOINING_APP_ROUTES.NOT_FOUND} />;

  return <>{children}</>;
};

export default FeatureFlagProtectedRoute;
